<h2 mat-dialog-title>Step 2: Select Products</h2>
<mat-dialog-content>
  <table class="product-table">
    <thead>
      <tr>
        <th>
          <mat-checkbox
            data-testid="select-all-checkbox"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            (change)="toggleAll()"
          ></mat-checkbox>
        </th>
        <th></th>
        <th>Barcode</th>
        <th>Reference</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      @for (product of availableProducts; track product.id) {
        <tr data-testid="product-row">
          <td>
            <mat-checkbox
              data-testid="product-checkbox"
              [checked]="isSelected(product)"
              (change)="toggle(product)"
            ></mat-checkbox>
          </td>
          <td class="thumbnail-cell">
            @if (product.thumbnailUri) {
              <img [src]="product.thumbnailUri" [alt]="product.barcode ?? ''" class="product-thumbnail" data-testid="product-thumbnail" />
            } @else {
              <div class="thumbnail-placeholder"></div>
            }
          </td>
          <td>{{ product.barcode }}</td>
          <td>{{ product.reference }}</td>
          <td>{{ product.description }}</td>
        </tr>
      }
    </tbody>
  </table>
  <div class="selection-counter" data-testid="selection-counter">
    {{ selectedCount() }} of {{ availableCount() }} selected
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" type="button">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" type="button" [disabled]="!hasSelection()">
    Next
  </button>
</mat-dialog-actions>
